import React, { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';
import { withTextSelection } from '../../../hocs/withTextSelection';

import RichTextArea from '../../../design-system/RichTextArea/RichTextArea';

const AssistantMessageContentWithFeedback = ({
    content,
    logFeedbackTrigger,
    feedbackAllowed,
    currentVersionId,
}) => {
    const [portalContainer, setPortalContainer] = useState(null);

    useEffect(() => {
        if (feedbackAllowed) {
            const container = document.querySelector(
                `.assistant_message_log_feedback_trigger[data-current-version-id="${currentVersionId}"]`
            );
            setPortalContainer(container);
        } else {
            setPortalContainer(null);
        }
    }, [feedbackAllowed]);

    return (
        <>
            <RichTextArea
                value={content}
                previewOnly
                autoExpand
                isBorderHidden
                customPreviewBgColor="transparent"
            />

            {feedbackAllowed &&
                portalContainer &&
                createPortal(logFeedbackTrigger, portalContainer)}
        </>
    );
};

const QuotableAssistantMessageContent = withTextSelection(AssistantMessageContentWithFeedback);

const WrappedAssistantMessageContentWithFeedback = (props) => {
    const { feedbackAllowed } = props;

    if (feedbackAllowed) {
        return <QuotableAssistantMessageContent {...props} />;
    }

    return <AssistantMessageContentWithFeedback {...props} />;
};

export default WrappedAssistantMessageContentWithFeedback;
